export const AVAILABILITY: Record<string, string> = {
  GA: '',
  BETA: 'BETA',
  ALPHA: 'ALPHA',
  NEW: 'NEW',
};

export const GLOBAL_MAX_WIDGETS_ALLOWED = 10;
export const SINGLE_SELECT = 'SINGLE';
export const MULTI_SELECT = 'MULTI';
export const DEFAULT_FLOW_COUNT = 3;
